export const isFullStatic = false
export const staticPath = "/Users/vunguyenokxe/Workspaces/OKXE/okxe-for-admin-frontend/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"